import {useMutation} from 'react-query';
import {postStoryClick} from '.';

export const usePostStoryClick = () => {
  const {mutate, isLoading} = useMutation({
    mutationKey: ['story-click'],
    mutationFn: (guid: string) => postStoryClick(guid),
  });
  return {mutate, isLoading};
};
